// extracted by mini-css-extract-plugin
export var title = "food-menu-module--title--3vlqO";
export var posts = "food-menu-module--posts--2yl6g";
export var foodMenuText = "food-menu-module--food-menu-text--3gnSr";
export var foodMenuImage = "food-menu-module--food-menu-image--1fWjY";
export var post = "food-menu-module--post--3DS8q";